import { getTickets, getInactiveTickets, getTicketsAwaitingApproval } from '../../api/TICKET/ticket';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

export const useTickets = (page, limit, search, filters = {}, tri = "date_debut", ordre = "DESC") => {
  return useQuery({
    queryKey: ['tickets', page, limit, search, filters, tri, ordre],
    queryFn: () => getTickets(page, limit, search, filters, tri, ordre),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
  });
};

export const useInactiveTickets = (page, limit, search, filters = {}, tri = "date_debut", ordre = "DESC") => {
  return useQuery({
    queryKey: ['inactiveTickets', page, limit, search, filters, tri, ordre],
    queryFn: () => getInactiveTickets(page, limit, search, filters, tri, ordre),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: (filters.statuses?.length ?? 2) > 0,
  });
};

export const useTicketsAwaitingApproval = (page, limit, search, filters = {}, tri = "date_debut", ordre = "DESC") => {
  return useQuery({
    queryKey: ['ticketsApproval', page, limit, search, filters, tri, ordre],
    queryFn: () => getTicketsAwaitingApproval(page, limit, search, filters, tri, ordre),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

// Polling hook — fetches all active tickets then filters client-side by userId (same pattern as Home.jsx)
export const useMyAssignedTickets = (userId) => {
  return useQuery({
    queryKey: ['myAssignedTickets'],
    queryFn: () => getTickets(1, 100, ""),
    enabled: !!userId,
    staleTime: 0,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    select: (data) => {
      const all = Array.isArray(data?.data?.tickets) ? data.data.tickets : [];
      return all.filter(t => t.users?.some(u => u.id === userId));
    },
  });
};
